const normalizeSearchValue = value => String(value ?? '')
    .trim()
    .toLocaleLowerCase('ru-RU');

export const filterDeviceItems = (items, query) => {
    const normalizedQuery = normalizeSearchValue(query);

    if (!normalizedQuery) {
        return items;
    }

    return items.filter(item => [
        item.placeName,
        item.address,
        item.placeLogin,
        item.placeId,
        item.deviceName,
        item.deviceId,
        item.appVersion,
        item.operatingSystem,
        item.licenseKeyPrefix
    ].some(value => normalizeSearchValue(value).includes(normalizedQuery)));
};
